import StudentWithdrawals from './StudentWithdrawals';

export default StudentWithdrawals;
